import React from "react";
import makeStyles from "@mui/styles/makeStyles";

import Button from "@mui/material/Button";

const useStyles = makeStyles(theme => ({
  "selected-outlined": {
    color: "white",
    backgroundColor: theme.palette.primary.main,
    borderColor: theme.palette.primary.main,
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
      borderColor: theme.palette.primary.main,
      color: "white",
    },
    "& span": {
      color: "white",
    },
  },
}));

const OrganizeButton = ({ variant, selected, ...otherProps }) => {
  const classes = useStyles();
  return (
    <Button
      className={selected ? classes[`selected-${variant}`] : undefined}
      variant={variant}
      {...otherProps}
    >
      {otherProps.children}
    </Button>
  );
};

export default OrganizeButton;
